export default {
    path: 'business_manage',
    name: 'business_manage',
    component: () => import('@/pages/business/Index'),
    meta: { title: '商务管理' },
    children: [

    ]
}
